<template>
  <v-footer
    app
    class="layout-footer elevation-2"
    color="primary"
  >
    <v-spacer />
    <span class="text-caption">Phoenix Graphics © 2025</span>
  </v-footer>
</template>

<style lang="sass">
  .layout-footer
    bottom: 0
    width: 100%
</style>
